import React, { Component } from "react";
import { MenuItem, Select, Button, DialogTitle, DialogActions } from "@material-ui/core";

import { t } from "js/i18n";
import { Gap20 } from "js/react/components/Gap";
import { BeautifulDialog, DialogContent } from "js/react/components/Dialogs/BaseDialog";
import { GridBox, ScrollBox } from "js/react/components/LayoutGrid";
import { FolderProfile, UserGroupProfile, UserProfile } from "js/react/components/Avatar";

export class ConfirmInviteDialog extends Component {
    state = {
        permission: "write",
    }

    handleChangePermissions = event => {
        this.setState({
            permission: event.target.value
        });
    }

    handleAccept = async () => {
        const { callback, closeDialog } = this.props;
        const { permission } = this.state;

        callback && callback(permission);
        closeDialog();
    }

    render() {
        const {
            title = t("Add the following collaborators?"),
            includeSubheader = true,
            hasPermissionEditing = false,
            collaborators,
            users,
            closeDialog
        } = this.props;
        const displayedCollaborators = collaborators ?? users ?? [];
        const { permission } = this.state;

        return (
            <BeautifulDialog id="confirmInvite" closeDialog={closeDialog}>
                <DialogTitle>{title}</DialogTitle>
                <DialogContent>
                    {
                        (includeSubheader || hasPermissionEditing) &&
                        <>
                            <label>
                                {
                                    hasPermissionEditing &&
                                    <>
                                        {displayedCollaborators.length > 0 ? t("These collaborators") : t("Collaborators")} will have
                                        <Select
                                            value={permission}
                                            onChange={this.handleChangePermissions}
                                            variant="outlined"
                                            style={{ margin: "0px 10px" }}
                                        >
                                            <MenuItem value="read">{t("View")}</MenuItem>
                                            <MenuItem value="write">{t("Edit")}</MenuItem>
                                        </Select>
                                        access{displayedCollaborators.length > 1 ? ":" : "."}
                                    </>
                                }
                                {
                                    !hasPermissionEditing &&
                                    <>
                                        {displayedCollaborators.length > 0 ? t("These collaborators") : t("Collaborators")} will be invited{displayedCollaborators.length > 1 ? ":" : "."}
                                    </>
                                }
                            </label>
                            <Gap20 />
                        </>
                    }
                    {displayedCollaborators.length > 0 && <ScrollBox fillWidth style={{ maxHeight: 370 }}>
                        <GridBox rows>
                            {displayedCollaborators.map(collaborator => {
                                if (collaborator.type === "folder") {
                                    return <FolderProfile key={collaborator.id} profile={collaborator} />;
                                }
                                if (collaborator.type === "group") {
                                    return <UserGroupProfile key={collaborator.id} profile={collaborator} />;
                                }
                                return <UserProfile key={collaborator.id} profile={collaborator} />;
                            })}
                        </GridBox>
                    </ScrollBox>}
                </DialogContent>
                <DialogActions>
                    <Button id="btnCancel" onClick={() => closeDialog()}>{t("Cancel")}</Button>
                    <Button id="btnOk" color="primary" onClick={this.handleAccept}>{t("Ok")}</Button>
                </DialogActions>
            </BeautifulDialog>
        );
    }
}
